export default __webpack_public_path__ + "f013699bdab764f70bf3bfb0194bdf2f.png";